import { FC, ReactNode } from 'react'

import { useCurrentUser } from '~/hooks'

const WizardOnly: FC<{ children: ReactNode }> = ({ children }) => {
  const currentUser = useCurrentUser()
  return <>{currentUser?.wizard ? children : null}</>
}

export default WizardOnly
